import React, { Component } from 'react';
import styled from 'styled-components';
import ColorPicker from 'rc-color-picker';

import { Button } from './Button';

const FilterWrapper = styled.div`
  width: 100%;
  padding: 5px;

  & input[type="number"] {
    width: 80px;
  }
`;

const FilterBox = styled.div`
  width: 100%;
  display:flex;
  justify-content: space-between
`;

export class ColorFilter extends Component {
  constructor(props) {
    super(props);
    this.handleChangeOneRl = this.handleChangeOneRl.bind(this);
    this.handleChangeTwoRl = this.handleChangeTwoRl.bind(this);
    this.handleChangeThreeRl = this.handleChangeThreeRl.bind(this);
    this.handleChangeOneQd = this.handleChangeOneQd.bind(this);
    this.handleChangeTwoQd = this.handleChangeTwoQd.bind(this);
    this.handleChangeThreeQd = this.handleChangeThreeQd.bind(this);
    this.handleChangeOneRlColor = this.handleChangeOneRlColor.bind(this);
    this.handleChangeTwoRlColor = this.handleChangeTwoRlColor.bind(this);
    this.handleChangeThreeRlColor = this.handleChangeThreeRlColor.bind(this);
    this.handleChangeFourRlColor = this.handleChangeFourRlColor.bind(this);
    this.handleChangeOneQdColor = this.handleChangeOneQdColor.bind(this);
    this.handleChangeTwoQdColor = this.handleChangeTwoQdColor.bind(this);
    this.handleChangeThreeQdColor = this.handleChangeThreeQdColor.bind(this);
    this.handleChangeFourQdColor = this.handleChangeFourQdColor.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeType = this.handleChangeType.bind(this);
    this.state = {
      type: props.colorFilter || 'false',
      oneRl: props.colorValues.oneRl || '1',
      twoRl: props.colorValues.twoRl || '2',
      threeRl: props.colorValues.threeRl || '3',
      oneQd: props.colorValues.oneQd || '1',
      twoQd: props.colorValues.twoQd || '2',
      threeQd: props.colorValues.threeQd || '3',
      oneRlColor: props.colorValues.oneRlColor || '#fff',
      twoRlColor: props.colorValues.twoRlColor || '#8ad9b5',
      threeRlColor: props.colorValues.threeRlColor || '#0b65aa',
      fourRlColor: props.colorValues.fourRlColor || '#e60046',
      oneQdColor: props.colorValues.oneQdColor || '#fff',
      twoQdColor: props.colorValues.twoQdColor || '#aaa039',
      threeQdColor: props.colorValues.threeQdColor || '#aa3939',
      fourQdColor: props.colorValues.fourQdColor || '#6a8467',
    };
  }

  handleChangeOneRl(e) {
    this.setState({oneRl: `${e.target.value}`});
  }

  handleChangeTwoRl(e) {
    this.setState({twoRl: `${e.target.value}`});
  }

  handleChangeThreeRl(e) {
    this.setState({threeRl: `${e.target.value}`});
  }

  handleChangeOneQd(e) {
    this.setState({oneQd: `${e.target.value}`});
  }

  handleChangeTwoQd(e) {
    this.setState({twoQd: `${e.target.value}`});
  }

  handleChangeThreeQd(e) {
    this.setState({threeQd: `${e.target.value}`});
  }

  handleChangeOneRlColor(e) {
    this.setState({oneRlColor: e.color});
  }

  handleChangeTwoRlColor(e) {
    this.setState({twoRlColor: e.color});
  }

  handleChangeThreeRlColor(e) {
    this.setState({threeRlColor: e.color});
  }

  handleChangeFourRlColor(e) {
    this.setState({fourRlColor: e.color});
  }

  handleChangeOneQdColor(e) {
    this.setState({oneQdColor: e.color});
  }

  handleChangeTwoQdColor(e) {
    this.setState({twoQdColor: e.color});
  }

  handleChangeThreeQdColor(e) {
    this.setState({threeQdColor: e.color});
  }

  handleChangeFourQdColor(e) {
    this.setState({fourQdColor: e.color});
  }

  handleSubmit() {
    this.props.submit({
      oneRl: this.state.oneRl,
      twoRl: this.state.twoRl,
      threeRl: this.state.threeRl,
      oneQd: this.state.oneQd,
      twoQd: this.state.twoQd,
      threeQd: this.state.threeQd,
      oneRlColor: this.state.oneRlColor,
      twoRlColor: this.state.twoRlColor,
      threeRlColor: this.state.threeRlColor,
      fourRlColor: this.state.fourRlColor,
      oneQdColor: this.state.oneQdColor,
      twoQdColor: this.state.twoQdColor,
      threeQdColor: this.state.threeQdColor,
      fourQdColor: this.state.fourQdColor,
    }, this.state.type);
  }

  handleChangeType(e) {
    this.setState({type: e.target.value});
  }

  render() {
    const {
      oneRl,
      twoRl,
      threeRl,
      oneQd,
      twoQd,
      threeQd,
      type,
      oneRlColor,
      twoRlColor,
      threeRlColor,
      fourRlColor,
      oneQdColor,
      twoQdColor,
      threeQdColor,
      fourQdColor,
    } = this.state;

    return (
      <FilterWrapper>
        <div style={{display: 'flex'}}>
          <div style={{ marginRight: '15px' }}>
            <input
              checked={type === 'rlqd'}
              id='color-rlqd'
              name="color"
              onChange={this.handleChangeType}
              type="radio"
              value="rlqd"
            />
            <label htmlFor="color-rlqd">
              RL / QD
            </label>
          </div>
          <div style={{ marginRight: '15px' }}>
            <input
              checked={type === 'false'}
              id='color-off'
              name="color"
              onChange={this.handleChangeType}
              type="radio"
              value="false"
            />
            <label htmlFor="color-off">
              OFF
            </label>
          </div>
        </div>
        <hr />
        <div>
          <span>
            RL
          </span>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={oneRlColor}
              onChange={this.handleChangeOneRlColor}
              placement="bottomRight"
            />
            <span>
              0 -
            </span>
            <input
              onChange={this.handleChangeOneRl}
              type="number"
              value={oneRl}
            />
          </FilterBox>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={twoRlColor}
              onChange={this.handleChangeTwoRlColor}
              placement="bottomRight"
            />
            <span>
              {`${parseInt(oneRl, 10) + 1} - `}
            </span>
            <input
              onChange={this.handleChangeTwoRl}
              type="number"
              value={twoRl}
            />
          </FilterBox>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={threeRlColor}
              onChange={this.handleChangeThreeRlColor}
              placement="bottomRight"
            />
            <span>
              {`${parseInt(twoRl, 10) + 1} - `}
            </span>
            <input
              onChange={this.handleChangeThreeRl}
              type="number"
              value={threeRl}
            />
          </FilterBox>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={fourRlColor}
              onChange={this.handleChangeFourRlColor}
              placement="bottomRight"
            />
            <span>
              {`${parseInt(threeRl, 10) + 1} -`}
            </span>
            <span style={{ width: '80px' }}>
              MAX
            </span>
          </FilterBox>
        </div>
        <hr />
        <div>
          <span>
            Qd
          </span>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={oneQdColor}
              onChange={this.handleChangeOneQdColor}
              placement="topRight"
            />
            <span>
              0 -
            </span>
            <input
              onChange={this.handleChangeOneQd}
              type="number"
              value={oneQd}
            />
          </FilterBox>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={twoQdColor}
              onChange={this.handleChangeTwoQdColor}
              placement="topRight"
            />
            <span>
              {`${parseInt(oneQd, 10) + 1} - `}
            </span>
            <input
              onChange={this.handleChangeTwoQd}
              type="number"
              value={twoQd}
            />
          </FilterBox>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={threeQdColor}
              onChange={this.handleChangeThreeQdColor}
              placement="topRight"
            />
            <span>
              {`${parseInt(twoQd, 10) + 1} - `}
            </span>
            <input
              onChange={this.handleChangeThreeQd}
              type="number"
              value={threeQd}
            />
          </FilterBox>
          <FilterBox>
            <ColorPicker
              animation="slide-up"
              color={fourQdColor}
              onChange={this.handleChangeFourQdColor}
              placement="topRight"
            />
            <span>
              {`${parseInt(threeQd, 10) + 1} -`}
            </span>
            <span style={{ width: '80px' }}>
              MAX
            </span>
          </FilterBox>
        </div>
        <Button
          block
          onClick={this.handleSubmit}
        >
          FILTER
        </Button>
      </FilterWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ColorFilter.js